import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=ae6a2e10&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae6a2e10')) {
      api.createRecord('ae6a2e10', component.options)
    } else {
      api.reload('ae6a2e10', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=ae6a2e10&", function () {
      api.rerender('ae6a2e10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Si36eypDqa1c/JS/offershelp.vue"
export default component.exports